// extracted by mini-css-extract-plugin
module.exports = {"menu":"dropdown-menu_menu__ax4aU","item":"dropdown-menu_item__3nx8j"};